var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#admon_svg__clip0_181_1890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.648 13.013H7.415v-1.149c-.96-.104-1.65-.438-2.068-.982l.648-.793a2.564 2.564 0 001.942.835c.857 0 1.525-.48 1.525-1.316a1.061 1.061 0 00-.647-.96 18.3 18.3 0 00-1.254-.44 4.13 4.13 0 01-1.336-.668 1.951 1.951 0 01-.606-1.503 1.805 1.805 0 01.501-1.254c.36-.346.808-.584 1.295-.689V2.987h1.233v1.086a3.622 3.622 0 011.67.752l-.605.731a2.663 2.663 0 00-1.609-.606c-.835 0-1.232.376-1.232 1.15 0 .438.439.793 1.274 1.064.92.293 1.546.544 1.838.752.439.335.669.899.669 1.65a2.09 2.09 0 01-.585 1.546 2.925 2.925 0 01-1.42.69v1.211zM8 16a8 8 0 118-8 8.015 8.015 0 01-8 8zM8 1.295A6.705 6.705 0 1014.705 8 6.714 6.714 0 008 1.295z",
    fill: "#979797"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "admon_svg__clip0_181_1890"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgAdmon;